import { DATE, formatDateNonUTC } from '../../../utils/date';
import { AgentMessage } from '../types';
import { Gutter } from './Gutter';

export const AgentContainer = ({ data }: { data: AgentMessage }) => {
  const { timestamp, message, agentName } = data;
  return (
    <div className='d-flex mb-3' style={{ animation: 'fadeIn 0.5s ease-in-out' }}>
      <Gutter icon={true}>
        <i className='fas fa-robot text-white fa-sm' />
      </Gutter>
      <div className='w-100 px-3 py-2 shadow-sm overflow-hidden bg-white' style={{ borderLeft: '4px solid #007bff' }}>
        <div className='d-flex text-ThemeTextLight justify-content-between align-items-center mb-1'>
          {agentName ? <small className='strong me-2'>{agentName}</small> : null}
          <small>{formatDateNonUTC(timestamp, DATE.HUMANIZE)}</small>
        </div>
        <div className='message-content mb-0'>{message}</div>
      </div>
      <Gutter right={true} />
    </div>
  );
};
